// Login
export const LOGIN_INITIATE = "LOGIN_INITIATE"; // Initiate Login
export const LOGIN_COMPLETE = "LOGIN_COMPLETE";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const LOGIN_BUTTON_CLICKED = "LOGIN_BUTTON_CLICKED";
export const LOGIN_MODAL_SHOW = "LOGIN_MODAL_SHOW";

// General
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const SHOW_NANOBAR = "SHOW_NANOBAR";
export const CLOSE_NANOBAR = "CLOSE_NANOBAR";
export const SHOW_CONTAINER_HEIGHT_CHANGED = "SHOW_CONTAINER_HEIGHT_CHANGED";

// Logout
export const LOGOUT_INITIATE = "LOGOUT_INITIATE"; // Initiate Logout
export const LOGOUT_COMPLETE = "LOGOUT_COMPLETE";
export const LOGOUT_FAILED = "LOGOUT_FAILED";

// Header Search
export const HEADER_SEARCH_EXPANDABLE_OPEN = "HEADER_SEARCH_EXPANDABLE_OPEN";
export const HEADER_SEARCH_EXPANDABLE_CLOSE = "HEADER_SEARCH_EXPANDABLE_CLOSE";

// Search Filters
export const SEARCH_FILTERS_MODAL_OPEN = "SEARCH_FILTERS_MODAL_OPEN";
export const SEARCH_FILTERS_MODAL_CLOSE = "SEARCH_FILTERS_MODAL_CLOSE";

// Leads
export const LEAD_MODAL_SHOW = "LEAD_MODAL_SHOW";
export const LEAD_MODAL_HIDE = "LEAD_MODAL_HIDE";

export const HIDE_ACTION_LOADER = "HIDE_ACTION_LOADER";

// DASHBOARD
export const DASHBOARD_REGIONS_RELOAD_RESULTS = "DASHBOARD_REGIONS_RELOAD_RESULTS";
export const DASHBOARD_REGIONS_MODAL_HIDE = "DASHBOARD_REGIONS_MODAL_HIDE";
export const DASHBOARD_AGENTS_MODAL_HIDE = "DASHBOARD_AGENTS_MODAL_HIDE";
export const DASHBOARD_LEADS_BUCKET_MODAL_HIDE = "DASHBOARD_LEADS_BUCKET_MODAL_HIDE";
export const DASHBOARD_AGENTS_RELOAD_RESULTS = "DASHBOARD_AGENTS_RELOAD_RESULTS";
export const DASHBOARD_LEADS_BUCKET_RELOAD_RESULTS = "DASHBOARD_LEADS_BUCKET_RELOAD_RESULTS";
export const DASHBOARD_AGENTS_PHONES_MODAL_HIDE = "DASHBOARD_AGENTS_PHONES_MODAL_HIDE";
export const DASHBOARD_AGENTS_PHONES_RELOAD_RESULTS = "DASHBOARD_AGENTS_PHONES_RELOAD_RESULTS";
export const DASHBOARD_RECON_MODAL_HIDE = "DASHBOARD_RECON_MODAL_HIDE";
export const DASHBOARD_RECON_RELOAD_RESULTS = "DASHBOARD_RECON_RELOAD_RESULTS";
export const DASHBOARD_PAYMENTS_MODAL_HIDE = "DASHBOARD_PAYMENTS_MODAL_HIDE";
export const DASHBOARD_PAYMENTS_RELOAD_RESULTS = "DASHBOARD_PAYMENTS_RELOAD_RESULTS";

// Dashboard Leads Page Modals
export const DASHBOARD_LEADS_TEMPLATES_MODAL_SHOW = "DASHBOARD_LEADS_TEMPLATES_MODAL_SHOW";
export const DASHBOARD_LEADS_TEMPLATES_MODAL_HIDE = "DASHBOARD_LEADS_TEMPLATES_MODAL_HIDE";
export const DASHBOARD_LEADS_STATS_MODAL_SHOW = "DASHBOARD_LEADS_STATS_MODAL_SHOW";
export const DASHBOARD_LEADS_STATS_MODAL_HIDE = "DASHBOARD_LEADS_STATS_MODAL_HIDE";
export const DASHBOARD_LEADS_TASKS_MODAL_SHOW = "DASHBOARD_LEADS_TASKS_MODAL_SHOW";
export const DASHBOARD_LEADS_TASKS_MODAL_HIDE = "DASHBOARD_LEADS_TASKS_MODAL_HIDE";
export const DASHBOARD_LEADS_FORMS_MODAL_SHOW = "DASHBOARD_LEADS_FORMS_MODAL_SHOW";
export const DASHBOARD_LEADS_FORMS_MODAL_HIDE = "DASHBOARD_LEADS_FORMS_MODAL_HIDE";
export const DASHBOARD_LEADS_PAYMENTS_MODAL_SHOW = "DASHBOARD_LEADS_PAYMENTS_MODAL_SHOW";
export const DASHBOARD_LEADS_PAYMENTS_MODAL_HIDE = "DASHBOARD_LEADS_PAYMENTS_MODAL_HIDE";
export const DASHBOARD_LEADS_ANALYTICS_MODAL_SHOW = "DASHBOARD_LEADS_ANALYTICS_MODAL_SHOW";
export const DASHBOARD_LEADS_ANALYTICS_MODAL_HIDE = "DASHBOARD_LEADS_ANALYTICS_MODAL_HIDE";
export const DASHBOARD_LEADS_ESCALATIONS_MODAL_SHOW = "DASHBOARD_LEADS_ESCALATIONS_MODAL_SHOW";
export const DASHBOARD_LEADS_ESCALATIONS_MODAL_HIDE = "DASHBOARD_LEADS_ESCALATIONS_MODAL_HIDE";

// Search Page
export const SEARCH_DETAILS_CARD_OPEN = "SEARCH_DETAILS_CARD_OPEN";
export const SEARCH_DETAILS_CARD_CLOSE = "SEARCH_DETAILS_CARD_CLOSE";
export const SEARCH_MAP_VIEW_SHOW = "SEARCH_MAP_VIEW_SHOW";
export const SEARCH_MAP_VIEW_HIDE = "SEARCH_MAP_VIEW_HIDE";
export const SEARCH_DETAILS_VIEW_SHOW = "SEARCH_DETAILS_VIEW_SHOW";
export const SEARCH_DETAILS_VIEW_HIDE = "SEARCH_DETAILS_VIEW_HIDE";
export const SEARCH_MAP_DIRECTIONS = "SEARCH_MAP_DIRECTIONS";
export const SEARCH_MAP_HIGHLIGHT = "SEARCH_MAP_HIGHLIGHT";
export const SEARCH_MAP_HIGHLIGHT_REMOVE = "SEARCH_MAP_HIGHLIGHT_REMOVE";
export const SEARCH_MAP_LOCATE = "SEARCH_MAP_LOCATE";
export const INVENTORY_SCROLL_INTO_VIEW = "INVENTORY_SCROLL_INTO_VIEW";
export const INVENTORY_SHORTLIST_ADDED = "INVENTORY_SHORTLIST_ADDED";
export const INVENTORY_SHORTLIST_REMOVED = "INVENTORY_SHORTLIST_REMOVED";
export const INVENTORY_SAVE = "INVENTORY_SAVE";
export const OPEN_HOW_IT_WORKS_MODAL = "OPEN_HOW_IT_WORKS_MODAL";
export const DISTANCE_FROM_LOCATION_FETCHED = "DISTANCE_FROM_LOCATION_FETCHED";
export const DISTANCE_SHOWN = "DISTANCE_SHOWN";
export const SCROLL_TO_MAP = "SCROLL_TO_MAP";
export const SET_MAP_CENTER = "SET_MAP_CENTER";
export const MAPBOX_LOADED = "MAP_BOX_LOADED";
export const HIGHLIGHT_INVENTORY_ON_MARKER_CLICK = "HIGHLIGHT_INVENTORY_ON_MARKER_CLICK";
export const HIGHLIGHT_INVENTORY_MARKER = "HIGHLIGHT_INVENTORY_MARKER";

// Shortlist
export const ADD_TO_SHORTLIST = "ADD_TO_SHORTLIST";
export const REMOVE_FROM_SHORTLIST = "REMOVE_FROM_SHORTLIST";

export const PARTNER_LEAD_LANDING_PAGE = "partner_lead_landing_page";
